module.exports = __webpack_public_path__ + "img/ali.35887422.png";